(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-picker"] && !Shopify.designMode) return;
  try {
    class QuantityBundlePicker extends HTMLElement {
    connectedCallback() {
      this.selected = this.querySelector('[data-bundle-selected]');
      this.addEventListener('change', this.onChange);
      const checked = this.querySelector('input[name="quantity"]:checked');
      if (checked) this.sync(checked, false);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
    }

    onChange = (event) => {
      const input = event.target;
      if (input instanceof HTMLInputElement && input.name === 'quantity') this.sync(input, true);
    };

    sync(input, notify) {
      if (this.selected && input.dataset.bundleLabel) this.selected.textContent = input.dataset.bundleLabel;
      const quantity = Number(input.value) || 1;
      // Lets the sticky add-to-cart bar show the chosen quantity (same event as Horizon's quantity selector)
      const event = new Event('quantity-selector:update', { bubbles: true });
      event.detail = { quantity };
      (notify ? this : document).dispatchEvent(event);
    }
  }

  if (!customElements.get('quantity-bundle-picker')) customElements.define('quantity-bundle-picker', QuantityBundlePicker);
  } catch(e) { console.error(e); }
})();

})();
